export default __webpack_public_path__ + "fonts/option-img2.svg";